"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOrderTypeToDisplayString = transformOrderTypeToDisplayString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
// duplicate transformOrderTypeToString
function transformOrderTypeToDisplayString(orderType) {
    switch (orderType) {
        case legacy_enums_1.OrderType.Private:
            return "Private";
        case legacy_enums_1.OrderType.Shared:
            return "Pool";
        default:
            return "Unknown";
    }
}
//# sourceMappingURL=transformOrderTypeToDisplayString.js.map